/**
 * Brief messages for things that happened away from where you tapped.
 *
 * The app had no way to say "that didn't work". Reactions, pins, deletes,
 * renames, mutes and profile saves all failed into console.error, so on bad
 * wifi the tap simply did nothing and kept doing nothing — people tap Delete
 * three times and wonder why the message is still there. Copy actions had the
 * opposite problem: they worked and said nothing, so a manager copying a join
 * link had no signal it had happened.
 *
 * A module-level emitter rather than context, matching `refreshChannels` in
 * state/unread.tsx: any lib or handler can call this without the component
 * tree having to thread a hook down to it.
 */

export type ToastTone = 'error' | 'info';

export interface Toast {
  id: number;
  message: string;
  tone: ToastTone;
}

const listeners = new Set<(toast: Toast) => void>();
let nextId = 1;

export function toast(message: string, tone: ToastTone = 'error'): void {
  const item: Toast = { id: nextId++, message, tone };
  for (const listener of listeners) listener(item);
}

/** Confirmation for something that succeeded quietly, like a copy. */
export function toastDone(message: string): void {
  toast(message, 'info');
}

export function subscribeToasts(listener: (toast: Toast) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
